import { useState } from 'react'
import { useAuth } from '../../auth/AuthContext'
import { useWalletBalances } from '../../hooks/useWalletBalance'
import { useWalletAdapterBridge } from '../../lib/walletBridge'
import SwapForm from './SwapForm'
import StakeForm from './StakeForm'
import LendForm from './LendForm'
import BorrowForm from './BorrowForm'
import RaydiumLpForm from './RaydiumLpForm'

type SubTab = 'swap' | 'stake' | 'lend' | 'borrow' | 'lp'

const TABS: { id: SubTab; label: string; hint: string }[] = [
  { id: 'swap',   label: 'Swap',   hint: 'Any → any via Jupiter' },
  { id: 'stake',  label: 'Stake',  hint: 'SOL → jupSOL' },
  { id: 'lend',   label: 'Lend',   hint: 'jupSOL as collateral' },
  { id: 'borrow', label: 'Borrow', hint: 'USDC against jupSOL' },
  { id: 'lp',     label: 'LP',     hint: 'SOL/USDC on Raydium' },
]

export default function TradeView() {
  const { portfolioId } = useAuth()
  const [sub, setSub] = useState<SubTab>('swap')
  const balances = useWalletBalances(portfolioId)
  useWalletAdapterBridge()

  return (
    <main className="mx-auto max-w-3xl px-3 py-4 sm:px-4 sm:py-6">
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-ink">Trade</h1>
        <p className="mt-1 text-xs text-gray-500">
          Direct on-chain actions via Jupiter + Raydium. Transactions are built server-side (Jupiter)
          or via SDK (Raydium, Jupiter Lend/Borrow) and signed by your connected wallet.
        </p>
      </div>

      <div className="mb-3 flex flex-wrap gap-1 rounded-lg border border-fringe bg-surface-card p-1">
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setSub(t.id)}
            className={`flex-1 min-w-[84px] rounded-md px-3 py-2 text-xs font-semibold transition-colors
              ${sub === t.id
                ? 'bg-accent-purple/25 text-ink'
                : 'text-ink-muted hover:bg-surface-hover hover:text-ink'}`}
            title={t.hint}
          >
            {t.label}
          </button>
        ))}
      </div>

      <section className="rounded-xl border border-fringe bg-surface-card p-4">
        {sub === 'swap'   && <SwapForm   balances={balances} />}
        {sub === 'stake'  && <StakeForm  balances={balances} />}
        {sub === 'lend'   && <LendForm   balances={balances} />}
        {sub === 'borrow' && <BorrowForm balances={balances} />}
        {sub === 'lp'     && <RaydiumLpForm balances={balances} />}
      </section>
    </main>
  )
}
